module.exports = __webpack_public_path__ + "static/media/logo_diva_prod.5ed71c6e.svg";